import myCoursesTemplate from './myCourses/template.html';

const usersCoursesState = {
  url: '/courses',
  stateName: 'Courses',
  data: {
    specialClass: 'fixed-sidebar'
  },
  abstract: true
};

const usersCoursesCourseState = {
  url: '/:courseId',
  stateName: 'Course',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/courses/:id'),
  },
  abstract: true
};

const usersCoursesCourseProgressState = {
  url: '/progress',
  stateName: 'Course Progress',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: '<self-study-progress></self-study-progress>'
    }
  }
};

const usersMyCoursesState = {
  url: '/my-courses',
  stateName: 'My Courses',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: myCoursesTemplate
    }
  }
};

export { usersMyCoursesState, usersCoursesState, usersCoursesCourseState, usersCoursesCourseProgressState };



// WEBPACK FOOTER //
// ./src/app/controllers/users/courses/index.js